import React, { Component } from "react";
import PropTypes from "prop-types";

import { Dimmer } from "semantic-ui-react";

class FullScreenModal extends Component {
  render() {
    return (
      <div>
        <div onClick={this.props.onClickTrigger}>{this.props.trigger}</div>
        <Dimmer
          page
          onClickOutside={this.props.onClickTrigger}
          active={this.props.show}
        >
          {this.props.content ? this.props.content : this.props.children}
        </Dimmer>
      </div>
    );
  }
}

FullScreenModal.propTypes = {
  trigger: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClickTrigger: PropTypes.func.isRequired,
  content: PropTypes.object,
};

export default FullScreenModal;
